import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class DuplicateRecordCommand extends CategoryCommand<TActionArgsValues> {
  public static COMMAND_NAME = 'duplicate' as const;

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.DUPLICATE,
    };
  }

  public getIcon(): IconName {
    return 'duplicate';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.DuplicateRecord;
  }

  public getName(): CommandName {
    return DuplicateRecordCommand.COMMAND_NAME;
  }

  public isAvailable(context: ClientContext): boolean {
    const id = context.get('Id');
    if (id === undefined) {
      return false;
    }
    const selected = context.get('SelectedIds');
    return (
      (context.has('ParentCategory') ||
        context.get('InParams')?.linksGraph?.mode !== DocLinksMode.SINGLE) &&
      (!selected ||
        selected.length === 0 ||
        (selected.length === 1 && selected[0] === id))
    );
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NEW;
  }
}

export default DuplicateRecordCommand;
